import { render, staticRenderFns } from "./thirteen.vue?vue&type=template&id=7054c8e5&scoped=true&"
import script from "./thirteen.vue?vue&type=script&lang=js&"
export * from "./thirteen.vue?vue&type=script&lang=js&"
import style0 from "./thirteen.vue?vue&type=style&index=0&id=7054c8e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7054c8e5",
  null
  
)

export default component.exports